import { useMedia } from "react-use";

import { VIEWPORT_TABLET } from "../lib/constants/viewports/viewportTablet";

export const useIsDesktopViewport = () =>
  useMedia(`(min-width: ${VIEWPORT_TABLET}px)`, false);
